import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import loaderWithRetry from "seneca-common/utils/loaderWithRetry";

import { SplashScreenForLoadableChunk } from "features/common/loadingScreens/components/SplashScreen";

import { linkToAnonymousWhatIsPremiumParent } from "./parent/links";
import { linkToAnonymousWhatIsPremiumTeacher } from "./teacher/links";

const LoadableAnonymousWhatIsPremiumParent = React.lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "anonymous-what-is-premium-parent" */ "./parent/Route"
      )
  )
);

const LoadableAnonymousWhatIsPremiumTeacher = React.lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "anonymous-what-is-premium-teacher" */ "./teacher/Route"
      )
  )
);

export default function WhatIsPremiumRoutes() {
  return (
    <Suspense fallback={<SplashScreenForLoadableChunk />}>
      <Switch>
        <Route path={linkToAnonymousWhatIsPremiumParent()}>
          <LoadableAnonymousWhatIsPremiumParent />
        </Route>
        <Route path={linkToAnonymousWhatIsPremiumTeacher()}>
          <LoadableAnonymousWhatIsPremiumTeacher />
        </Route>
        <Redirect to={linkToAnonymousWhatIsPremiumParent()} />
      </Switch>
    </Suspense>
  );
}
